// Modules
import styled from "styled-components"

// Constants
import colors from "~constants/colors"

export const ModalBottom = styled.div`
  align-items: center;
  background-color: ${colors.gray5};
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  display: flex;
  justify-content: space-between;
  padding: 20px;

  > .title {
    color: black;
    font-size: 18px;
    font-weight: bold;
  }
`

export const ModalTitle = styled.h2`
  color: ${colors.blue1};
  font-size: 20px;
  margin-bottom: 30px;
`

export const ModalText = styled.p`
  color: ${colors.gray7};
  font-size: 18px;
  margin: 0;
`

export const ModalSuccessContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const ModalSuccessTitle = styled.h3`
  color: ${colors.blue1};
`

export const ModalSuccessText = styled.p`
  color: ${colors.blue1};
  margin: 0;
  text-align: center;
  width: 40%;
`
export const ModalSubtitle = styled.h2`
  color: ${colors.blue1};
  font-size: 18px;
  margin-bottom: 30px;
`
